import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { PositionedEvent } from '@/@types/Calendar';
import { formatTime } from '@/helpers/calendarUtils';

type VisualState = 'none' | 'invited' | 'joined' | 'declined';


export default /*#__PURE__*/_defineComponent({
  __name: 'CalendarEventCard',
  props: {
    event: null,
    isSelected: { type: Boolean, default: false }
  },
  emits: ["open-detail"],
  setup(__props: any) {

const props = __props as { event: PositionedEvent, isSelected: boolean }





const isCompact = computed(() => props.event.height < 40);

const timeRange = computed(() => {
  const start = formatTime(props.event.event.startTime);
  const end = formatTime(props.event.event.endTime);
  return `${start} \u2013 ${end}`;
});

/**
 * Map the 8 backend bot statuses to 4 visual states:
 *   none                         → 'none'     (grey, no badge)
 *   inviting / invited           → 'invited'  (grey + purple badge)
 *   accepted / recorded          → 'joined'   (green + green badge)
 *   declined / failed / skipped  → 'declined' (grey + red badge, no fade/strikethrough)
 */
const VISUAL_STATE_MAP: Record<string, VisualState> = {
  none: 'none',
  inviting: 'invited',
  invited: 'invited',
  accepted: 'joined',
  recorded: 'joined',
  declined: 'declined',
  failed: 'declined',
  skipped: 'declined',
};

const visualState = computed<VisualState>(() => {
  const status = props.event.event.botInviteStatus || 'none';
  return VISUAL_STATE_MAP[status] || 'none';
});

const visualStateClass = computed(() => `calendar-event-card--${visualState.value}`);

/** Badge variant — null means no badge (for 'none' state) */
const badgeVariant = computed<VisualState | null>(() => {
  const state = visualState.value;
  return state === 'none' ? null : state;
});

const cardStyle = computed(() => ({
  top: `${props.event.top}px`,
  height: `${props.event.height}px`,
  width: `calc((100% - 4px) / ${props.event.totalColumns})`,
  left: `calc(${props.event.columnIndex} * 100% / ${props.event.totalColumns})`,
}));

return { __sfc: true,props, isCompact, timeRange, VISUAL_STATE_MAP, visualState, visualStateClass, badgeVariant, cardStyle }
}

})